import i18n from 'i18next';
import { parse, parseISO, isBefore, isEqual } from 'date-fns';
import { TravellerFieldEnum, DocTypes } from '@websky/graphql';
import { getTravellerFullName, getPassengerTypeLabel } from '../utils';
import { formatInvalidPassengerDate, hideText } from '../Passenger/utils';
export const collectPassengerInfo = (traveller) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    let travellerName;
    const travellerMainInfo = [];
    const travellerAdditionalInfo = [];
    const travellerLoyaltyInfo = [];
    const travellerValues = new Map(traveller.values.map(params => [params.type, params]));
    if (travellerValues.has(TravellerFieldEnum.LastName)) {
        travellerName = getTravellerFullName(traveller);
    }
    else {
        travellerName = getPassengerTypeLabel(traveller.type, traveller.supplierTravellerType);
    }
    if (travellerValues.has(TravellerFieldEnum.Gender)) {
        const genderValue = travellerValues.get(TravellerFieldEnum.Gender).value;
        const genderName = (_c = (_b = (_a = travellerValues
            .get(TravellerFieldEnum.Gender)) === null || _a === void 0 ? void 0 : _a.validationRules) === null || _b === void 0 ? void 0 : _b[0].options.find(({ value }) => value === genderValue)) === null || _c === void 0 ? void 0 : _c.label;
        if (genderName) {
            travellerMainInfo.push(i18n.t(`OrderCard:Gender_${genderName}`));
        }
    }
    if (travellerValues.has(TravellerFieldEnum.BirthDate)) {
        const birthDate = formatInvalidPassengerDate(TravellerFieldEnum.BirthDate, travellerValues.get(TravellerFieldEnum.BirthDate).value);
        travellerMainInfo.push(birthDate);
    }
    const nationalityValue = travellerValues.has(TravellerFieldEnum.Nationality)
        ? travellerValues.get(TravellerFieldEnum.Nationality).value
        : null;
    if (nationalityValue) {
        const nationalityName = (_f = (_e = (_d = travellerValues
            .get(TravellerFieldEnum.Nationality)) === null || _d === void 0 ? void 0 : _d.validationRules) === null || _e === void 0 ? void 0 : _e[0].options.find(({ value }) => value === nationalityValue)) === null || _f === void 0 ? void 0 : _f.label;
        if (nationalityName) {
            travellerMainInfo.push(nationalityName);
        }
    }
    if (travellerValues.has(TravellerFieldEnum.DocType)) {
        const docType = travellerValues.get(TravellerFieldEnum.DocType).value;
        const docNumber = (_g = travellerValues.get(TravellerFieldEnum.DocNumber)) === null || _g === void 0 ? void 0 : _g.value;
        const isPassport = docType === DocTypes.Passport;
        const isBirthRegDocument = docType === DocTypes.BirthRegDocument;
        const isHideDocExpiryDate = isPassport || isBirthRegDocument;
        if (docNumber) {
            travellerAdditionalInfo.push(`${i18n.t(`Passenger:${docType}`)}: ${hideText(docNumber)}`);
        }
        if (!isHideDocExpiryDate && ((_h = travellerValues.get(TravellerFieldEnum.DocExpiryDate)) === null || _h === void 0 ? void 0 : _h.value)) {
            const expireDate = formatInvalidPassengerDate(TravellerFieldEnum.DocExpiryDate, travellerValues.get(TravellerFieldEnum.DocExpiryDate).value);
            travellerAdditionalInfo.push(`${i18n.t('OrderCard:Expired date')}: ${expireDate}`);
        }
    }
    if (travellerValues.has(TravellerFieldEnum.LoyaltyNumber) &&
        ((_j = travellerValues.get(TravellerFieldEnum.LoyaltyNumber)) === null || _j === void 0 ? void 0 : _j.value)) {
        const loyaltyNumber = travellerValues.get(TravellerFieldEnum.LoyaltyNumber).value;
        travellerLoyaltyInfo.push(`${i18n.t('Passenger:loyaltyName')}: ${loyaltyNumber}`);
    }
    return {
        travellerName,
        mainInfo: travellerMainInfo,
        additionalInfo: travellerAdditionalInfo,
        loyaltyInfo: travellerLoyaltyInfo,
        ticketNumbers: ((_k = traveller.tickets) === null || _k === void 0 ? void 0 : _k.map(ticket => ticket === null || ticket === void 0 ? void 0 : ticket.number)) || []
    };
};
// ключ - кто сопровождает, значение - кого сопровождают
export const getAdultAccompaniedMap = (travellers) => {
    const passengerAccompaniedMap = new Map();
    travellers.forEach(traveller => {
        var _a, _b;
        if ((_a = traveller.linkedTraveller) === null || _a === void 0 ? void 0 : _a.id) {
            passengerAccompaniedMap.set(traveller.linkedTraveller.id, [
                ...((_b = passengerAccompaniedMap.get(traveller.linkedTraveller.id)) !== null && _b !== void 0 ? _b : []),
                traveller
            ]);
        }
    });
    return passengerAccompaniedMap;
};
export const isTravellerOlderThanMinDate = (traveller, relinkingTraveller) => {
    var _a, _b, _c, _d;
    const minBirthDateAsStr = (_c = (_b = (_a = relinkingTraveller.values.find(value => value.type === TravellerFieldEnum.LinkedTraveller)) === null || _a === void 0 ? void 0 : _a.validationRules) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.minDate;
    const travellerBirthDateAsStr = (_d = traveller.values.find(value => value.type === TravellerFieldEnum.BirthDate)) === null || _d === void 0 ? void 0 : _d.value;
    if (!minBirthDateAsStr || !travellerBirthDateAsStr) {
        return true;
    }
    const travellerBirthDate = parse(travellerBirthDateAsStr, 'yyyy-MM-dd', new Date());
    const minBirthDate = parseISO(minBirthDateAsStr);
    return isBefore(travellerBirthDate, minBirthDate) || isEqual(travellerBirthDate, minBirthDate);
};
